/**
 * @generated SignedSource<<47836fe80b58f7c03b4d016b0036c0f7>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type FileStatus = "ERROR" | "PENDING" | "PROCESSING" | "READY" | "WAIT_FOR_PROCESSING";
export type FileUploadAreaStatusQuery$variables = {
  fileIds: ReadonlyArray<string>;
  skip: boolean;
};
export type FileUploadAreaStatusQuery$data = {
  readonly listFiles?: ReadonlyArray<{
    readonly id: string;
    readonly name: string | null;
    readonly status: FileStatus;
  }>;
};
export type FileUploadAreaStatusQuery = {
  response: FileUploadAreaStatusQuery$data;
  variables: FileUploadAreaStatusQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "fileIds"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "skip"
  }
],
v1 = [
  {
    "condition": "skip",
    "kind": "Condition",
    "passingValue": false,
    "selections": [
      {
        "alias": null,
        "args": [
          {
            "kind": "Variable",
            "name": "fileIds",
            "variableName": "fileIds"
          }
        ],
        "concreteType": "File",
        "kind": "LinkedField",
        "name": "listFiles",
        "plural": true,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "name",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "status",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "FileUploadAreaStatusQuery",
    "selections": (v1/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "FileUploadAreaStatusQuery",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "7fa31d719dd5962c09d7682871e26bc4",
    "id": null,
    "metadata": {},
    "name": "FileUploadAreaStatusQuery",
    "operationKind": "query",
    "text": "query FileUploadAreaStatusQuery(\n  $fileIds: [ID!]!\n  $skip: Boolean!\n) {\n  listFiles(fileIds: $fileIds) @skip(if: $skip) {\n    id\n    name\n    status\n  }\n}\n"
  }
};
})();

(node as any).hash = "961377c1c183ff5a7da0c917f4f003b2";

export default node;
